/* FÉNIX R18.1 — suppress sticky ATC while a real purchase CTA is visible. */
(function(){
  'use strict';
  var body=document.body;
  if(!body || !body.classList.contains('template-product')) return;

  var targets=[
    document.getElementById('AddToCart'),
    document.querySelector('.nm-pdp-secondary-ctas')
  ].filter(Boolean);
  if(!targets.length) return;

  var visible=new Set();
  function sync(){
    body.classList.toggle('nm-r181-sticky-suppressed',visible.size>0);
  }

  function fallback(){
    visible.clear();
    targets.forEach(function(el){
      var r=el.getBoundingClientRect();
      if(r.bottom>0 && r.top<window.innerHeight) visible.add(el);
    });
    sync();
  }

  if('IntersectionObserver' in window){
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting && entry.intersectionRatio>0.04) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      sync();
    },{threshold:[0,.04,.15,.5]});
    targets.forEach(function(el){observer.observe(el)});
  }else{
    fallback();
    window.addEventListener('scroll',fallback,{passive:true});
    window.addEventListener('resize',fallback,{passive:true});
  }
})();
